import useScreenSize from '../../hooks/useScreenSize'
import OTPInput from 'otp-input-react';
import { ButtonGroup, WelcomeText } from './Login';
import Typography from '../../components/typography/Typography';
// import { Typography } from '@mui/material';
import appLogo from '../../assets/logo/app-logo.svg'
import { useDispatch, useSelector } from 'react-redux';
import { setPageModeOtp, setTimeRemaining, setUserOtp } from '../../store/slice/auth/authenticationSlice';
import { toast } from 'react-toastify';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useThrottle from '../../hooks/useThrottle';
import { loginWithOTP, verifyWithOTP } from '../../store/builders/auth/auth.builders.js'
import { UI_CONSTANT } from '../../utility/constants.js';


export function VerifyOtp() {
  const screenSize = useScreenSize()
  const dispatch = useDispatch()
  const { loading, pageModeOtp, userPhone, userOtp, accessToken, timeRemaining } = useSelector((state) => state.auth) || {}
  // const [timeRemaining, setTimeRemaining] = useState(30)
  const [timerCompleted, setTimerCompleted] = useState(false)
  const [OTP, setOTP] = useState('');
  const [errors] = useState({})
  const [isFormValid, setIsFormValid] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (window.location.pathname == '/verify-otp') {
      dispatch(setPageModeOtp('otp'))
    }
    if (!userPhone) {
      window.location.pathname = '/login'
    }
  }, [])

  useEffect(() => {
    if (pageModeOtp === 'otp') {
      setIsFormValid(OTP.trim().length === 4 && !errors.OTP)
    }
  }, [OTP, errors.OTP, dispatch, pageModeOtp])

  // useEffect(() => {
  //   let timer
  //   if (timeRemaining > 0) {
  //     timer = setInterval(() => {
  //       setTimeRemaining((prevTime) => prevTime - 1)
  //     }, 1000)
  //     setTimerCompleted(false)
  //   } else {
  //     clearInterval(timer)
  //     setTimerCompleted(true)

  //     // setTimeRemaining(30);
  //   }

  //   return () => clearInterval(timer)
  // }, [OTP, timeRemaining, dispatch])

  const handleResetOTP = async () => {
    dispatch(setUserOtp('reset'))
    if (userPhone) {
      const phone = userPhone
      dispatch(loginWithOTP({ phone, navigate }))

    }
  }
  const handleLogin = async () => {
    const token = accessToken?.result?.token
    const otp = OTP
    if (timeRemaining == 0) {
      toast.error('OTP expired', {
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      });

    } else {
      dispatch(verifyWithOTP({ otp, token, navigate }))
    }
  }

  const handleThrottleLogin = useThrottle(handleLogin, 2000)

  const handleEnterClick = (e) => {
    e.preventDefault();
    if (e.key === 'Enter' || e.keyCode === 13) {
      // handleLogin()
      handleThrottleLogin()
    }
  }
  return (
    <div className='wrapper'>
      <div className='container flex justify-center align-center'>
        <div className='section logo-section flex justify-center align-center'>
          <div className='container'>
            <img src={appLogo} alt='App Logo' />
          </div>
        </div>
        <div className='section login-section flex justify-center align-center'>
          <form onSubmit={handleEnterClick} className={`container ${screenSize} flex flex-column justify-evenly`}>
            <WelcomeText resetOtp={userOtp} title={UI_CONSTANT.LOGIN.WELCOME_TITLE} message={UI_CONSTANT.LOGIN.WELCOME_MESSAGE} pageModeOtp={pageModeOtp} userPhone={userPhone} loading={loading} />
            <div className='input-wrapper flex flex-column justify-center align-center'>
              <OtpInput setOTP={setOTP} OTP={OTP} setTimerCompleted={setTimerCompleted} timerCompleted={timerCompleted} />
            </div>
            <ButtonGroup
              type="submit"
              handleThrottleLogin={handleThrottleLogin}
              loading={loading}
              isFormValid={isFormValid}
              timerCompleted={timerCompleted}
              errors={errors}
              pageModeOtp={pageModeOtp}
            // onKeyDown={handleEnterClick}
            />
          </form>

          <div className='resend-otp-wrapper flex justify-center'>
            {/* <Button variant='normal'> */}
            <Typography>
              <span style={{ color: timerCompleted ? 'dark-silver' : 'inherit', cursor: '' }}>
                Don&apos;t send OTP ?
                {timerCompleted ? (
                  <span
                  style={{ color: timerCompleted ? 'red' : 'dark-silver', cursor: 'pointer', paddingLeft: '5px' }}
                  onClick={handleResetOTP}
                >
                  {UI_CONSTANT.LOGIN.RESEND_OTP}
                </span>
              ) : (
                <span
                  style={{ color:'dark-silver', paddingLeft: '5px',cursor:'not-allowed' }}
                >
                  {UI_CONSTANT.LOGIN.RESEND_OTP}
                </span>
                )}
              </span>
            </Typography>
            {/* </Button> */}
          </div>

        </div>
      </div>
    </div>
  )
}

export function OtpInput({ OTP, setOTP, setTimerCompleted }) {
  const screenSize = useScreenSize();
  const dispatch = useDispatch();
  const { timeRemaining } = useSelector((store) => store.auth);

  useEffect(() => {
    const id = setInterval(() => {
      if (timeRemaining > 0) {
        dispatch(setTimeRemaining(timeRemaining - 1));
        setTimerCompleted(false);
      } else {
        setTimerCompleted(true);
        clearInterval(id);
      }
    }, 1000);

    return () => clearInterval(id);
  }, [dispatch, timeRemaining]);

  const otpInputMemo = useMemo(() => (
    <OTPInput
      value={OTP}
      onChange={setOTP}
      autoFocus
      OTPLength={4}
      separator={<span style={{ width: '8px' }}></span>}
      isInputNum={true}
      shouldAutoFocus={true}
      otpType="number"
      inputStyle={{
        border: '1px solid transparent',
        borderRadius: '8px',
        width: '50px',
        height: '50px',
        fontSize: '12px',
        color: '#000',
        fontWeight: '400',
        caretColor: 'blue',
      }}
      focusStyle={{
        border: '1px solid #CFD3DB',
        outline: 'none',
      }}
    />
  ), [OTP, setOTP]);

  const counterMemo = useMemo(() => (
    <div className={`counter ${screenSize}`}>{`00 : ${timeRemaining?.toString().padStart(2, '0')}`}</div>
  ), [screenSize, timeRemaining]);

  return (
    <div className='otp-count-wrapper flex flex-column align-center '>
      <div className='otp-boxes flex align-center justify-between'>
        {otpInputMemo}
      </div>
      {counterMemo}
    </div>
  );
}
